module.exports = __webpack_public_path__ + "media/img/payment-methods/paypal-ac4ea4408f5a3c3c3ba419da13f33610.svg";